// TODO remove commented-out blocks?

import { THEME_CART_UPDATED } from 'events';
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';
import { getCart } from 'utils/cart';
// import { uniqueName } from 'utils/variant';

export default component((node, ctx) => {
  const data = JSON.parse(node.querySelector('.js-data').innerHTML);
  const form = node.querySelector('form');

  // const initOptions = () => {
  //   const select = node.querySelector('.js-select');
  //   const wishlistItem = Wishlist.items.find((item) => item.handle === data.handle);
  //   const selectedVariant = data.variants.find((variant) => variant.id === wishlistItem.id);
  //   const addToCart = node.querySelector('.js-add-to-cart');
  //   const tags = data.tags ?? [];

  //   const changeEvent = document.createEvent('HTMLEvents');
  //   changeEvent.initEvent('change', false, true);

  //   const callback = (variant) => {
  //     if (variant) {
  //       select.textContent = uniqueName(data, variant);

  //       if (variant.available) {
  //         addToCart.textContent = theme.strings.product.form.addToCart;
  //         addToCart.disabled = false;
  //       } else {
  //         addToCart.textContent =
  //           theme.strings.product.form[tags.includes('coming_soon') ? 'comingSoon' : 'soldOut'];
  //         addToCart.disabled = true;
  //       }
  //     } else {
  //       addToCart.textContent = theme.strings.product.form.unavailable;
  //       addToCart.disabled = true;
  //     }
  //   };

  //   const selector = new Shopify.OptionSelectors(`product-${data.id}`, {
  //     product: data,
  //     onVariantSelected: callback,
  //   });

  //   if (selectedVariant) {
  //     select.textContent = uniqueName(data, selectedVariant);

  //     selector.selectors.forEach((item, index) => {
  //       item.element.value = selectedVariant.options[index];
  //       item.element.dispatchEvent(changeEvent);
  //     });
  //   } else {
  //     select.textContent = theme.strings.product.form.selectVariant;

  //     addToCart.disabled = true;
  //     addToCart.textContent = theme.strings.product.form.selectVariant;
  //   }

  //   document.addEventListener('theme:variant:selected', ({ detail }) => {
  //     const variant = data.variants.find((item) => item.id === detail.id);

  //     if (variant) {
  //       Wishlist.add(data.handle, variant.id);

  //       selector.selectors.forEach((item, index) => {
  //         item.element.value = variant.options[index];
  //         item.element.dispatchEvent(changeEvent);
  //       });
  //     }
  //   });
  // };

  // const initForm = () => {
  //   form.addEventListener('submit', async (event) => {
  //     event.preventDefault();

  //     await fetch(`${form.action}.js`, {
  //       method: form.method,
  //       body: new FormData(form),
  //     });

  //     await getCart().then((response) => {
  //       ctx.emit(THEME_CART_UPDATED, { cart: response });
  //     });
  //   });
  // };

  const initVariant = () => {
    form.addEventListener('input', () => {
      setTimeout(() => {
        const formData = new FormData(form);
        const id = formData.get('id');
        Wishlist.remove(data.handle);
        Wishlist.add(data.handle, id);
      }, 0);
    });
  };

  // initOptions();
  // initForm();
  initVariant();
});
